'use client';

import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '~/lib/query-client';
import { Toaster } from '~/components/ui';
import { SessionProvider } from 'next-auth/react';
import { ThemeContextsProvider } from '~/contexts';
import NextTopLoader from 'nextjs-toploader';

interface ProvidersProps {
  children: React.ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ThemeContextsProvider>
          <NextTopLoader color="#6366F1" height={3} showSpinner={false} />
          {children}
        </ThemeContextsProvider>
      </SessionProvider>
      <Toaster position="bottom-center" richColors />
    </QueryClientProvider>
  );
}
